import { useEffect, useRef } from 'react';

export default function useScreenAudio({ introSound, backgroundSound, exitSound, countdownSound, countdownAt = 5, timeLeft } = {}) {
  const introRef = useRef(null);
  const bgRef = useRef(null);
  const countdownRef = useRef(null);
  const exitSoundRef = useRef(exitSound);

  useEffect(() => {
    exitSoundRef.current = exitSound;
  }, [exitSound]);

  // Countdown sound: plays once when timeLeft hits countdownAt, stops at 0
  useEffect(() => {
    if (!countdownSound) return;
    if (timeLeft === countdownAt) {
      const audio = new Audio(countdownSound);
      countdownRef.current = audio;
      audio.play().catch(() => {});
    }
    if (timeLeft <= 0 && countdownRef.current) {
      countdownRef.current.pause();
      countdownRef.current = null;
    }
  }, [countdownSound, countdownAt, timeLeft]);

  useEffect(() => {
    let cancelled = false;

    function startBackground() {
      if (cancelled || !backgroundSound) return;
      const bg = new Audio(backgroundSound);
      bg.loop = true;
      bgRef.current = bg;
      bg.play().catch(() => {});
    }

    if (introSound) {
      const intro = new Audio(introSound);
      introRef.current = intro;
      intro.play().catch(() => {});
      intro.addEventListener('ended', startBackground);
    } else {
      startBackground();
    }

    return () => {
      cancelled = true;

      if (introRef.current) {
        introRef.current.pause();
        introRef.current = null;
      }
      if (bgRef.current) {
        bgRef.current.pause();
        bgRef.current = null;
      }

      if (exitSoundRef.current) {
        const exit = new Audio(exitSoundRef.current);
        exit.play().catch(() => {});
      }
    };
  }, [introSound, backgroundSound]);
}
